"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INVESTOWN_CURRENCY = void 0;
exports.INVESTOWN_CURRENCY = 'CZK';
//# sourceMappingURL=investown-currency.js.map